<div class="d-lg-block d-none">
  <fgb-banner [title]="'ecash.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <div class="d-lg-none d-block pt-3 container">
    <fgb-navigation-pills [navItems]="jetCashNavItems" />
  </div>
  <div class="container pt-lg-4">
    <div class="cards-container d-lg-none d-block">
      <fgbcl-card-token-list
        [regex]="regex"
        [provider]="provider"
        [redirectUrl]="'/cardtoken/success'"
        [failureUrl]="'/cardtoken/failure'"
      ></fgbcl-card-token-list>
    </div>

    <div class="d-lg-block d-none">
      <h5 class="text-black font-page-heading text-capitalized text-center">{{ 'ecash.page.access.card' | translate }}</h5>
      <div class="text-center font-size-14">
        {{ 'ecash.page.qr.text' | translate }}
      </div>
    </div>
    <div class="pb-4">
      <fgbcl-card-link-earn-steps
        [cardTitle]="'payment.description.title'"
        [stepOneIcon]="'credit_card'"
        [stepTwoIcon]="'qr_code_scanner'"
        [stepThreeIcon]="'emoji_events'"
        [stepOneText]="'payment.description.step.one'"
        [stepTwoText]="'payment.description.step.two'"
        [stepThreeText]="'payment.description.step.three'"
        [horizontalLine]="true"
        [filled]="true"
        [border]="false"
      >
      </fgbcl-card-link-earn-steps>
    </div>
    <div class="cards-container d-lg-block d-none">
      <div class="cards-container">
        <fgbcl-card-token-list
          [regex]="regex"
          [provider]="provider"
          [redirectUrl]="'/cardtoken/success'"
          [failureUrl]="'/cardtoken/failure'"
        ></fgbcl-card-token-list>
      </div>

      <div class="d-lg-block d-none pb-5">
        <p class="font-page-heading text-uppercase heading-text transaction-header-text">
          {{ 'transaction.history.title' | translate }}
        </p>
        <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
      </div>
    </div>
  </div>
</div>
